import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ServiceCatalog from '../../components/services/ServiceCatalog';
import { serviceCategories } from '../../data/services';
import settings from '../../constants/settings';

const Services = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [initialCategory, setInitialCategory] = useState('Semua');
  const headerRef = useRef(null);
  
  // Extract category from URL query parameters
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const categoryParam = searchParams.get('category');
    
    // Check if the category from URL exists in our categories
    if (categoryParam && serviceCategories.includes(categoryParam)) {
      setInitialCategory(categoryParam);
      
      // Scroll to header when category is set from URL
      if (headerRef.current) {
        headerRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (categoryParam) {
      // If category is invalid, redirect to the services page without query params
      navigate('/services', { replace: true });
    }
  }, [location.search, navigate]);  // Using location.search instead of location to detect query changes

  return (
    <div className="bg-white pt-[90px]">
      <div ref={headerRef} className="bg-cream/30 py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-4 text-center">
            Layanan Kami
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto text-center">
            Berbagai layanan untuk membantu persiapan studi luar negeri kamu, dari konsultasi hingga bimbingan belajar.
          </p>
        </div>
      </div>
      
      <ServiceCatalog initialCategory={initialCategory} />
      
      <div className="bg-cream/20 py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="bg-white rounded-lg shadow-md p-8 max-w-3xl mx-auto">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4 text-center">
              Butuh Layanan Khusus?
            </h2>
            <p className="text-gray-600 mb-6 text-center">
              Jika Anda membutuhkan layanan yang tidak tercantum di atas atau ingin informasi lebih lanjut, jangan ragu untuk menghubungi kami.
            </p>
            <div className="flex justify-center">
              <button
                className="inline-flex items-center justify-center bg-gold hover:bg-dark-navy text-white font-medium rounded-md px-6 py-3 transition-colors"
                onClick={() => {
                  const consultantNumber = settings.wa_consultant_link.replace('https://wa.me/', '');
                  window.open(`https://wa.me/${consultantNumber}?text=${encodeURIComponent('Saya ingin bertanya tentang layanan khusus')}`, '_blank');
                }}
              >
                <svg
                  className="w-5 h-5 mr-2"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                </svg>
                Hubungi Kami
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;